import {
  SET_LANGUAGE,
  SET_DIRECTION,
  SET_COUNTRY_POPUP,
} from "../../actions/types/types";

const initState = {
  language: "en",
  direction: "ltr",
  showCountryPopup: true,
};


const LanguageDirectionReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_LANGUAGE:
      return {
        ...state,
        language: action.payload.data,
      };
    case SET_DIRECTION:
      return {
        ...state,
        direction: action.payload.data,
      };
    case SET_COUNTRY_POPUP:
      return {
        ...state,
        showCountryPopup: action.payload.data,
      };
    default:
      return { ...state };
  }
};

export default LanguageDirectionReducer;
